<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <!-- 共用彈跳視窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogData.show"
      width="30%">
      <span>{{dialogData.content}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogData.show = false">取 消</el-button>
        <el-button size="mini" type="warning" @click="dialogData.confirm">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'dialogData'
    ])
  }
};
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue